import { observer } from 'mobx-react-lite';

import { Breadcrumb } from '@components/breadcrumb';
import { Header } from '@components/header';
import { PageContainers } from '@components/page-containers';
import { PageContent } from '@components/page-containers/page-container';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useStore } from 'models/Provider';

import { Password } from './password';
import { TwoFactor } from './two-factor';

export const Security = observer(() => {
  const { current } = useStore();
  const { t } = useScopedTranslate(locale);

  return (
    <Stack space={8}>
      <Header breadcrumbs={<Breadcrumb items={[{ label: t('security') }]} />} />
      <PageContent>
        <PageContainers.MiddleColumnPage>
          <Stack space={6}>
            <Text font="regular14" color="textSecondary" text={t('manageYourPassword')} />
            <Separator />

            <Password />
            {current.info.use2FA && (
              <>
                <Separator />
                <TwoFactor />
              </>
            )}
          </Stack>
        </PageContainers.MiddleColumnPage>
      </PageContent>
    </Stack>
  );
});

export const locale = {
  en: {
    security: 'Security',
    manageYourPassword: 'Manage your password and authentication methods',
  },
  is: {
    security: 'Öryggi',
    manageYourPassword: 'Stjórna lykilorði og auðkenningaraðferðum þínum',
  },
};
